function EnrolleesControls() {
    "use strict";

    this.CardView = null;
    this.CardViewTimer = null;
    this.CardViewOffenderFilter = null;
    this.CardViewVictimFilter = null;
    this.CardViewOffenderPaginator = null;
    this.CardViewVictimPaginator = null;

    // Map
    this.EnrolleesMap = null;
    this.TimelineMap = null;
    this.NotificationPanel = null;
    this.EnrolleeMapLocate = null;
    this.OffenderTrackpointDetailCardView = null;
    this.LatestAssociationsListView = null;
    this.OffenderTrackpointDetailCardViewFilter = null;
    this.OffenderSecondaryEnrolleeListView = null;
    this.MapSettingsListView = null;
    this.PlaybackControl = null;
    this.LabelEditValidator = null;
    this.PrimaryEnrolleeTimer = null;
    this.SecondaryEnrolleeTimer = null;
    //heat map
    this.OffenderHeatMap = null;
    this.OffenderHeatMapCardView = null;
    this.OffenderHeatMapCardViewFilter = null;
    this.OffenderAddHeatMapCardView = null;
    this.OffenderHeatMapHelpPopup = null;


    this.LegendDropdown = null;
    this.DetailsDropdown = null;
    this.LocateDropdown = null;
    this.NotesDropdown = null;
    this.SettingsDropdown = null;

    // Profile
    this.OffenderProfileValidator = null;
    this.VictimProfileValidator = null;

    // Events
    this.EventsListView = null;
    this.EventsListViewFilter = null;
    this.EventsNotesManager = null;
    this.EventsListViewPaginator = null;
    // Notes
    this.NotesManager = null;

    // Contact History
    this.ContactHistoryListView = null;

    // Device Assignments
    this.DeviceAssignmentsListView = null;
    this.DeviceAssignmentsMap = null;
    this.DeviceAssignmentsContactList = null;
    this.TrackingDeviceCardView = null;
    this.StationCardView = null;
    this.AddOnCardView = null;
    this.DeviceAssignmentsValidator = null;
    this.DeviceAssignmentsWizard = null;
    this.BluHomeEditValidator = null;

    // Schedules
    this.SchedulesListView = null;
    this.SchedulesView = null;
    this.SchedulesTargetCardView = null;
    this.SchedulesBluPlusConfigurationListView = null;
    this.veritracksCalendar = null;

    // Addresses
    this.AddressesMap = null;
    this.AddressesValidator = null;

    // Notifications VICTIM
    this.VictimNotificationsListView = null;

    // Chart Mapping
    this.veritracksChartMap = null;
    this.veritracksChartMiniMap = null;
    this.TimelinePlacesListView = null;
    this.TimelinePlacesValidator = null;
    this.TimelineAddressValidator = null;
    // carving schedule
    this.CarvingValidator = null;
    // Print
    this.PrintMap = null;
    //blubox map
    this.blueBoxMap = null;

    //threads control
    this.Threads = null;

    //associations
    this.EnrolleesCorrelateMap = null;

    //associations
    this.EnrolleesLatestAssociationsMap = null;

    //sobertrack
    this.SoberTrackTestResultControl = null;

    //EMA 
    this.EMACheckInHistoryListView = null;

    //Eid
    this.EidQuotaListView = null;
}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleesControls;
}